import {SET_REDIRECT_URL} from './actions';

export const redirectUrl = (url = null, action) => {
  switch (action.type) {
    case SET_REDIRECT_URL:
      return action.value.redirectUrl;
    default:
      return url;
  }
};
